// A navigation link of the shell (menu, tabs, « More »): a real <a href> —
// so long-press / ⌘-click / middle-click still open it elsewhere — whose plain
// tap navigates through the 200 ms route transition (lib/appShell/routeTransition).
import type { AnchorHTMLAttributes, MouseEvent, ReactNode } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { navigateWithTransition } from '@/lib/appShell/routeTransition';

interface Props extends Omit<AnchorHTMLAttributes<HTMLAnchorElement>, 'href'> {
  to: string;
  children: ReactNode;
  /** Runs before navigating (closing the « More » sheet). */
  onGo?: () => void;
}

export function ShellLink({ to, onGo, onClick, children, ...rest }: Props) {
  const navigate = useNavigate();
  const handle = (e: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(e);
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    onGo?.();
    navigateWithTransition(() => navigate(to));
  };
  return <Link to={to} onClick={handle} {...rest}>{children}</Link>;
}
